module.exports = __webpack_public_path__ + "static/media/banner-video.9fffa221.png";